import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container } from 'reactstrap';
import Swal from 'sweetalert2';

import { addApiList, getApiList, updateApiList, deleteApiList, testApiListReset } from '../../../store/apiList/actions';
import { getClients } from '../../../store/actions';

import { ITable } from '../../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import FormDetails from './form-details';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import usePageTitle from '../../../common/hooks/usePageTitle';

const ApiList = (props: any) => {
    const dispatch = useDispatch();
    const { listData } = useSelector((state: any) => state.ApiList);
    const { clients } = useSelector((state: any) => state.clients);

    const PageTitleAPI = usePageTitle(props.location.pathname);

    const [listDataState, setListDataState] = useState([]);
    const [tableViewList, settableViewList] = useState([]);
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);

    const textClient = 'Search Client ID';
    const textIdentificator = 'Search Identificator';
    const textName = 'Search Name';

    const [queryObject, setQueryObject] = useState<any>({});
    const [queryString, setQueryString] = useState<any>({});

    const valuesSizeClientsPagination = [50, 100, 150, 200, 250, 300];
    const [paginationClients, setPaginationClients] = useState<any>({
        sizePerPage: valuesSizeClientsPagination[0],
        page: 1,
    });

    // SOLVE PAGE LOADING AFTER ADDING AND UPLOADING
    useEffect(() => {
        dispatch(getApiList({ data: queryString }));
        dispatch(getClients({}));
    }, []);

    useEffect(() => {
        let userConsultName = false;
        let userConsultIdentificator = false;

        const queryTextIdentificator = queryString[textIdentificator] ?? '';
        const queryTextName = queryString[textName] ?? '';

        if (queryTextIdentificator.length > 3 || queryTextIdentificator === '') {
            userConsultName = true;
        }
        if (queryTextName.length > 3 || queryTextName === '') {
            userConsultIdentificator = true;
        }

        if (userConsultName && userConsultIdentificator) {
            dispatch(getApiList({ data: queryString }));
        }
    }, [queryString]);

    useEffect(() => {
        setListDataState(listData);
        if (selectedRow) {
            const newArray = listData.filter((item: any) => item.id === selectedRow.id)[0];
            setSelectedRow(newArray);
        }
    }, [listData]);

    const initialArrayTable = [
        {
            text: 'Identificator',
            dataField: 'identificator',
            sort: true,
            formatter: (cellContent: any, listData: any) => <>{listData.identificator}</>,
        },
        {
            text: 'Name',
            dataField: 'name',
            sort: true,
            formatter: (cellContent: any, listData: any) => <>{listData.name}</>,
        },
        {
            text: 'Host',
            dataField: 'host',
            sort: true,
            formatter: (cellContent: any, listData: any) => <>{listData.host}</>,
        },
        {
            text: 'Company',
            dataField: 'company',
            sort: true,
            formatter: (cellContent: any, listData: any) => <>{listData.company}</>,
        },
        {
            text: 'Client ID',
            dataField: 'clientId',
            sort: true,
            formatter: (cellContent: any, listData: any) => <>{listData.clientId}</>,
        },
        {
            text: 'Description',
            dataField: 'description',
            sort: true,
            formatter: (cellContent: any, listData: any) => <>{listData.description}</>,
        },
        {
            text: 'enabled',
            dataField: 'enabled',
            formatter: (cellContent: any, listData: any) => {
                return (
                    <ISwitch
                        checked={listData.enabled}
                        onChangeBooleanHandler={(args) => {
                            const newObject = { ...listData };
                            newObject.enabled = args;
                            dispatch(updateApiList({ newObject, data: queryString }));
                        }}
                    />
                );
            },
            hidden: false,
        },
        // {
        //   text: "Tmp Token",
        //   dataField: "tmpToken",
        // },
    ];
    const initialArrayTableClients = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
            hidden: false,
        },
    ];

    const obje = ['identificator', 'name', 'username', 'host', 'wsdl', 'company', 'clientId', 'description', 'tmpToken', 'password', 'enabled'];

    const handleCreate = (data: any) => {
        setpopUpState(!popUpState);
        //dispatch(getApiList(client));
        dispatch(addApiList({ data, queryString }));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
        //dispatch(getClients());
    };

    const handlesetpopUpState = (state: any) => {
        dispatch(testApiListReset());
        setpopUpState(state);
    };

    const handleUpdate = (data: any) => {
        setpopUpState(!popUpState);
        dispatch(updateApiList({ newObject: data, data: queryString }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        });
        //dispatch(getClients());
    };

    const handleCancel = (id: any) => {
        setpopUpState(!popUpState);
        dispatch(testApiListReset());
    };

    const handleDelete = (id: any) => {
        setpopUpState(!popUpState);
        dispatch(deleteApiList({ id, data: queryString }));
        Swal.fire({
            icon: 'success',
            title: 'Deleted!!!',
            text: 'Items have been deleted successfully!!!',
        });
        //dispatch(getClients());
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };

    const handlePaginationClientsChange = (newState: any) => {
        setPaginationClients(newState);
    };
    const onChangeSelectorHandler = (n: any, value: any) => {
        setQueryString({ ...queryString, [n]: value.id });
        setQueryObject(value);
    };

    const onChangeHandler = (e: any, n: any) => {
        if (n === 'Search Client ID') {
            const newObject = clients.filter((item: any) => Number(item.id) === Number(e.target.value))[0];
            setQueryObject(newObject);
        }
        setQueryString({ ...queryString, [n]: e.target.value });
    };

    const AdminFilters = () => {
        return (
            <>
                <div className="col ">
                    <div className="justify-content-center">
                        <ISelector
                            title={textClient}
                            value={queryObject?.id || queryString[textClient] || ''}
                            nameSelector={queryObject?.name ?? ''}
                            valuesSizePagination={valuesSizeClientsPagination}
                            CountItems={clients?.length}
                            dataSelector={clients}
                            initialArrayTable={initialArrayTableClients}
                            handlePaginationChange={handlePaginationClientsChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="col">
                    <div className="justify-content-center">
                        <IInput title={textIdentificator} type={'text'} value={queryString[textIdentificator]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
                <div className="col ">
                    <div className="justify-content-center">
                        <IInput title={textName} type={'text'} value={queryString[textName]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
            </>
        );
    };

    return (
        <React.Fragment>
            <div>
                {/* <div id="menuColumn"></div> */}
                <div id="navbar"></div>
                <div className="pageContent" style={{ padding: '20px 20px 0 20px' }}>
                    <PageTitle>
                        <title>{PageTitleAPI.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                    <Container fluid>
                        <div className="row justify-content-end me-2">
                            <div className="d-flex justify-content-end pb-3">
                                <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                                    + Add
                                </button>
                            </div>
                            {AdminFilters()}
                        </div>

                        <Col lg="12">
                            <ITable
                                data={listDataState}
                                fields={initialArrayTable}
                                tableColumns={initialArrayTable}
                                pagSize={4}
                                pageStartIn={0}
                                showTotal={true}
                                disablePageTitle={true}
                                headerColorT={'bg-primary text-white'}
                                tableViewList={tableViewList}
                                groupName=""
                                handlePopUpState={onPopUpState}
                                actionOnRowClick={handleActionOnRowClick}
                            />
                        </Col>
                    </Container>
                </div>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={handlesetpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={'Api'}
                modaleTitleUpdate={'Update Api'}
                icon="code"
                colorHeaderPop={'#101340'}
            >
                <FormDetails
                    selectedRow={selectedRow}
                    onCreate={handleCreate}
                    onUpdate={handleUpdate}
                    onDelete={handleDelete}
                    onCancel={handleCancel}
                    adminFilters={queryString}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default ApiList;
